export function hasPartSelection(part) {
  return (Number.isInteger(Number(part?.uzdpart360_part_id)) && Number(part.uzdpart360_part_id) > 0)
    || Boolean(part?.part_name?.trim());
}

export function buildQueryPartWrite(part) {
  const canonicalId = Number(part?.uzdpart360_part_id);
  const identity = Number.isInteger(canonicalId) && canonicalId > 0
    ? { uzdpart360_part_id: canonicalId }
    : { part_name: part?.part_name?.trim() };
  return {
    ...identity,
    quantity: part?.quantity || 1,
    ...(part?.side && { side: part.side }),
    ...(part?.condition_preference != null && { condition_preference: part.condition_preference }),
    ...(part?.part_number?.trim() && { part_number: part.part_number.trim() }),
  };
}

export function canonicalPartSelectionPatch(part, id, option, alias) {
  const canSuggestSide = !part?._side_manually_edited && (!part?.side || part?._side_auto_suggested);
  return {
    uzdpart360_part_id: id,
    part_name: option?.name || "",
    ...(canSuggestSide ? {
      side: alias?.implied_side || null,
      _side_auto_suggested: Boolean(alias?.implied_side),
    } : {}),
  };
}
